import { render, staticRenderFns } from "./SystemAdministration.vue?vue&type=template&id=d76f0dee&scoped=true&"
import script from "./SystemAdministration.vue?vue&type=script&lang=js&"
export * from "./SystemAdministration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d76f0dee",
  null
  
)

export default component.exports